import router from "./router";
import { MessageBox } from 'element-ui'
import Axios from "./Axios";
import store from "./store";

const whiteRoute = ['Home', 'search', 'help', 'Login', 'information', 'Register', 'download', 'lookSpecialty', 'NewsList', 'Detail', 'lookCollege', 'Recommend', 'server', 'vip', 'art_detail', 'art_solution']

const loginRoute = ['info', 'specialtyInfo', 'CollegeInfo', 'schoolNews', 'solution', 'provinceLine', 'ranking', 'lookData', 'myAssess', 'myCard', 'review', 'ChangePwd', 'goodsInfo', 'chooseSpecialty']

//vip 路由 1
const VipList = ['info', 'specialtyInfo', 'CollegeInfo', 'specialty', 'schoolNews', 'solution', 'provinceLine', 'ranking', 'lookData', 'myAssess', 'myCard', 'review', 'ChangePwd', 'CollegeFirst', 'MajorFirst', 'ReportTable', 'escort', 'goodsInfo', 'collegeScoreLine', 'SpecialtyScore', 'getPlan', 'otherBatch', 'otherBatchScore', 'newChooseSubject', 'newSpecialtySearch', 'chooseSpecialty', 'newSubjectUser', 'analyse', 'advanceBatch', 'strong_base', 'special_plan', 'score', 'score-other', 'hld', 'hldResult', 'chat'
]

//美术类 2
const artVipList = ['info', 'specialtyInfo', 'CollegeInfo', 'specialty', 'schoolNews', 'solution', 'provinceLine', 'ranking', 'lookData', 'myAssess', 'myCard', 'review', 'ChangePwd', 'CollegeFirst', 'MajorFirst', 'ReportTable', 'escort', 'goodsInfo', 'collegeScoreLine', 'SpecialtyScore', 'getPlan', 'otherBatch', 'otherBatchScore', 'newChooseSubject', 'newSpecialtySearch', 'chooseSpecialty', 'newSubjectUser', 'analyse', 'advanceBatch', 'strong_base', 'special_plan', 'art_college_list', 'art_calculate', 'art_volunteer', 'report_table_art', 'artCollege', 'score-other', 'score', 'hld', 'hldResult', 'chat'
]
const token = localStorage.getItem('TOKEN')

if (token) {
  Axios.post('user_info/getUserInfo').then(res => {
    if (res) {
      store.commit('setInfo', res)
    }
  })
}


router.beforeEach((to, from, next) => {
  // 是否登录
  // to: Route: 即将要进入的目标 路由对象
  // from: Route: 当前导航正要离开的路由
  // next: Function: 一定要调用该方法来 resolve 这个钩子。执行效果依赖 next 方法的调用参数。



  //回到首页
  if (to.name == null) {
    router.push('/')
  }
  //如果是白名单。直接访问不用注册直接访问
  if (whiteRoute.indexOf(to.name) >= 0) {
    next()
  } else {
    //如果不是白名单 判断是否登录 登录可看
    // 判断是否登录

    if (token) {
      const is_wenli = store.state.userInfo.is_wenli
      // 如果没有文理科。直接跳转到修改个人信息
      if (!is_wenli && to.name != 'information') {
        next(`/information?redirect=${to.path}`)
        return
      }
      const VIP = store.state.userInfo.is_vip  // 判断VIP类型
      switch (VIP) {
        case 0:
          if (loginRoute.indexOf(to.name) > -1) {
            next()
          } else {
            MessageBox.confirm('该功能仅VIP用户可用！', '提示', {
              center: true,
              confirmButtonText: '开通vip',
              callback: action => {
                if (action === 'confirm') {
                  router.push('/vip')
                }
              }
            })
            return
          }
          break;
        case 1:
          if (VipList.indexOf(to.name) > -1) {
            next()
          } else {
            MessageBox.confirm('该功能仅VIP美术类用户可用！！！', '提示', {
              center: true,
              confirmButtonText: '开通vip',
              callback: action => {
                if (action === 'confirm') {
                  router.push('/vip')
                }
              }
            })
            return
          }
          break;
        case 2:
          if (artVipList.indexOf(to.name) > -1) {
            next()
          } else {
            MessageBox.confirm('该功能仅VIP美术类用户可用！', '提示', {
              center: true,
              confirmButtonText: '开通vip',
              callback: action => {
                if (action === 'confirm') {
                  router.push('/vip')
                }
              }
            })
            return
          }
          break;
      }
    } else {
      //去登录页面
      MessageBox.confirm('该功能仅注册用户可用！', '提示', {
        center: true,
        confirmButtonText: '注册',
        callback: action => {
          if (action === 'confirm') {
            router.push('/Login')
          }
        }
      })
    }
  }
})



